import React, { memo } from 'react';

import iconClose from '../../../assets/images/close.svg';

import './style.css';

function ModalViewImages(props) {
  const Modal = ({ message, onClose }) => {
    return (
      <div className="view-modal-dialog">
        <div className="view-modal-header">
          <div />
          <button onClick={onClose} type="button" className="button-close">
            <img src={iconClose} alt="close-modal" />
          </button>
        </div>
        <div className="view-modal-content">
          {message.type === 'IMAGE' ? (
            <img
              className="view-midia"
              src={message.image || message.imageUrl || message.message}
              alt={message.title || 'Preview Image'}
            />
          ) : (
            <video
              autoPlay
              controls
              className="view-midia"
              title={message.video?.title || message.title}
            >
              <track kind="captions" />
              <source
                src={message.video?.fileUrl || message.message}
                type="video/mp4"
              />
            </video>
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`view-modal ${
        Object.values(props.message).length > 0 && 'view-modal-show'
      }`}
      tabIndex="-1"
      onClick={props.onClose}
    >
      <Modal message={props.message} onClose={props.onClose} />
    </div>
  );
}

export default memo(ModalViewImages);
